import Grid from '@material-ui/core/Grid'
import React from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import makeStyles from '@material-ui/core/styles/makeStyles'
import TextField from '@material-ui/core/TextField'

import { colors, strings } from '../../utils'

import { FormControl } from '../../components/Forms'

const { limit, keepOnlyNumbers, upcase } = strings

const useStyles = makeStyles(theme => ({
  container: {
    margin: '8px',
    marginBottom: '8px',
    width: '100%',
  },
  legend: {
    marginBottom: '8px',
  },
  formControl: {
    width: '100%',
  },
  controlLabel: {
    '& .MuiRadio-root': {
      padding: '4px 8px',
    },
  },
  radio: {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  text: {
    width: '100%',
    marginTop: '8px',
  },
  number: {
    width: '100%',
    marginTop: '8px',
  },
}))

const handleText = text => upcase(limit(text, 250))

const Question = ({ disabled, question, setAnswer, validating, scope }) => {
  const classes = useStyles()

  const { answerId, extra, id, title, options = [] } = question || {}

  const groupName = scope ? `question-${id}-${scope}` : `question-${id}`

  const radioClasses = () =>
    colors.portalTheme().coloredRadios ? { root: classes.radio } : {}

  const sortedOptions = () =>
    options.sort((a, b) => (a.sequence > b.sequence ? 1 : -1))

  const renderAnswerExtra = () => {
    const answeredOption = options.find(i => i.id === answerId) || {}

    if (['text', 'number'].includes(answeredOption.kind)) {
      return (
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              className={
                answeredOption.kind === 'text' ? classes.text : classes.number
              }
              disabled={disabled || validating}
              label="Resposta"
              variant="outlined"
              name={`extra-text-${id}`}
              value={extra === 0 ? 0 : extra || ''}
              onChange={e =>
                setAnswer(
                  answerId,
                  answeredOption.kind === 'text'
                    ? handleText(e.target.value)
                    : keepOnlyNumbers(e.target.value)
                )
              }
            />
          </FormControl>
        </Grid>
      )
    }

    return <></>
  }

  return (
    <div className={classes.container}>
      <Grid item xs={12}>
        <FormControl className={classes.formControl}>
          <FormLabel component="legend" className={classes.legend}>
            {title}
          </FormLabel>

          <RadioGroup
            aria-label="quiz"
            name={groupName}
            value={answerId || ''}
            onChange={e => setAnswer(parseInt(e.target.value), undefined)}
          >
            {sortedOptions().map(opt => (
              <FormControlLabel
                disabled={disabled || validating}
                className={classes.controlLabel}
                key={opt.id}
                value={opt.id}
                control={<Radio classes={radioClasses()} />}
                label={opt.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>

      {!!answerId && renderAnswerExtra()}
    </div>
  )
}

export default Question
